/**
 * 错误码映射表
 */
export const ErrorCodeMap: Record<number, string> = {
  // 成功
  0: '成功',

  // 认证与授权 (1000-1999)
  1001: '用户未登录或token无效',
  1002: '用户无权限访问',
  1003: 'token已过期',
  1004: '用户名或密码错误',
  1005: '权限不足',

  // 参数校验 (2000-2999)
  2001: '参数无效',
  2002: '缺少必需参数',
  2003: '格式错误',
  2004: '请求无效',
  2005: '验证失败',

  // 资源相关 (3000-3999)
  3001: '资源不存在',
  3002: '资源已存在',
  3003: '资源冲突',
  3004: '资源已删除',
  3005: '资源不可用',

  // 工作流相关 (4000-4999)
  4001: '工作流不存在',
  4002: '工作流已存在',
  4003: '工作流定义无效',
  4004: '工作流正在运行',
  4005: '工作流已停止',
  4006: '工作流执行失败',
  4007: '工作流执行超时',
  4008: '工作流已取消',
  4009: '执行记录不存在',
  4010: '执行失败',
  4011: '执行正在进行中',
  4012: '执行已完成',

  // 项目相关 (5000-5999)
  5001: '项目不存在',
  5002: '项目已存在',
  5003: '项目访问被拒绝',
  5004: '项目无效',

  // 数据库相关 (6000-6999)
  6001: '数据库错误',
  6002: '数据库连接失败',
  6003: '数据库操作超时',
  6004: '数据库约束违反',

  // 服务器内部错误 (9000-9999)
  9001: '内部服务器错误',
  9002: '服务不可用',
  9003: '配置错误',
  9004: '系统错误',
  9999: '未知错误',
};

export default ErrorCodeMap;
